import { v3 } from "oc-threejs/short3";
import { Spherical } from "three";

/**
 * der folgende Code ist aus OrbitControls copiert und überarbeitet,
 * um mehr Kontrolle zu haben und garantiert an den Ausgangseinstellungen zurückzukehren
 **/
export class MiniOrbitControls {
  target = v3();
  spherical = new Spherical();
  originalTarget = v3();
  originalSpherical = new Spherical();
  offset = v3();
  controls = APP.controls;

  reset() {
    // this.controls.saveState();
    this.controls.resetFromObjectAndTarget();
    this.target.copy(this.controls.target);
    this.offset = this.controls.object.position.clone().sub(this.controls.target);
    this.spherical.setFromVector3(this.offset);
    this.spherical.makeSafe();
    this.originalTarget.copy(this.controls.target);
    this.originalSpherical.copy(this.spherical);
  }

  _update() {
    this.offset.setFromSpherical(this.spherical);
    this.controls.object.position.copy(this.target).add(this.offset);
    this.controls.target.copy(this.target);
    this.controls.object.lookAt(this.target);
    STAGE.dirty();
  }

  rotate(theta: number, phi: number) {
    this.spherical.theta = this.originalSpherical.theta + theta;
    this.spherical.phi = this.originalSpherical.phi + phi;
    this._update();
  }

  translate(x, y) {
    this.target.x = this.originalTarget.x + x;
    this.target.z = this.originalTarget.z + y;
    this._update();
  }

  zoom(z: number) {
    this.spherical.radius = this.originalSpherical.radius * z;
    this._update();
  }
}
